import { AccessTokenPayload } from '../Types/Varios.ts';
import { Checking } from './Checking.tsx';
import { PropsWithChildren, ReactNode } from 'react';
import { Forbidden } from './Forbidden.tsx';
import { UserMetadataWrapper } from './UserMetadataWrapper.tsx';
import { configureSentryInfo } from '../Utils/Sentry.ts';
import debug from 'debug';
import Session from 'supertokens-auth-react/recipe/session';

export interface CheckerProps extends PropsWithChildren {
    forbiddenComponent?: Element;
    checkingComponent?: Element;
    onlyAdmin?: boolean;
    onlyUser?: boolean;
}

const log = debug('auth');
// log.enabled = true;

export function Checker({
    checkingComponent,
    forbiddenComponent,
    onlyAdmin = false,
    onlyUser = false,
    children,
}: CheckerProps) {
    const checkingSession = Session.useSessionContext();
    log('checkeando sesion');
    if (checkingSession.loading) {
        log('cargando...');
        return (checkingComponent ?? <Checking />) as ReactNode;
    }

    if (!checkingSession.doesSessionExist) {
        log('no existe sesión, redirect al login', { checkingSession });
        const url = new URL('/login', window.location.href);
        url.searchParams.append('redirectTo', window.location.href);
        //refresh forzado en vez de setLocation porque no anda...
        window.location.href = url.toString();
        return null;
    }
    const payload = {
        ...checkingSession.accessTokenPayload,
        id: checkingSession.userId,
    } as AccessTokenPayload;
    log('sessión info: ', { checkingSession });
    log('payload: %O', payload);

    //Tomo los datos que vienen del payload, menos jwt y se los paso a sentry
    configureSentryInfo(checkingSession.userId, payload);

    if (onlyAdmin && !payload.is_sadmin) {
        return (forbiddenComponent ?? <Forbidden />) as ReactNode;
    }
    if (onlyUser && payload.is_sadmin) {
        return (forbiddenComponent ?? <Forbidden />) as ReactNode;
    }

    return (
        <UserMetadataWrapper payload={payload}>{children}</UserMetadataWrapper>
    );
}
